import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_cvheqfzi: FaireBrandEntity = {
  token: "b_cvheqfzi",
  type: "brand",
  name: "Komoni Natural Wellness + BodyCare",
  avatarUrl:
    "https://cdn.faire.com/fastly/838e1095ad0dde8dfb8c069baf537104b1c5a04ab4bcfa99340a00cbc34f1912.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/03fdff8638a746b391265937299a091af40939845a0e8e17377121945266d593.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/838e1095ad0dde8dfb8c069baf537104b1c5a04ab4bcfa99340a00cbc34f1912.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/03fdff8638a746b391265937299a091af40939845a0e8e17377121945266d593.jpeg",
  location: "Plymouth, MN, USA",
  minimumOrderDollars: 75,
  rating: 4.9,
  reviewCount: 56,
  isInsider: true,
  description:
    "At Komoni Natural Wellness and Body Care, we craft high-quality, natural products designed for everyday wellness and multi-purpose use — all at fair prices. As a family-owned business, we take pride in offering a variety of unique, giftable lines that make a beautiful addition to your store. Our vibrant, eco-conscious packaging is naturally eye-catching on the shelves and reflects the care and intention behind every product we make.\n\nGuided by fairness and sustainability, we honor and support the communities behind our ingredients by giving back to Fair Trade USA every month. Our ongoing donations help ensure that farmers and workers receive fair wages, safe working conditions, and the opportunity to build stronger, more sustainable futures.\n\nProudly made in the USA, each product is beautifully packaged and ready to ship!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:34.435Z",
    importedBy: "entity-db-cli",
  },
};
